import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PhoneService } from './service'

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [PhoneService],
  exports: [],
})
export class PhoneStoreModule {}
